var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ItpUsercontrol",
    {
      attrs: {
        loading: _vm.loading,
        reloading: _vm.reloading,
        loaded: _vm.loaded,
        error: _vm.error
      },
      on: {
        reload: function($event) {
          return _vm.evh_7315092382398562_reload($event, {})
        }
      }
    },
    [
      _c(
        "DIV",
        { staticClass: "card my-3" },
        [
          _c(
            "DIV",
            { staticClass: "card-body" },
            [
              _c("H5", [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm._f("gettext")("NAV online invoice interface")) +
                    "\n      "
                )
              ]),
              _vm._v(" "),
              _c("P", { staticClass: "card-text" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm._f("pgettext")(
                        "Import invoices from NAV online invoices service.",
                        "Tasks"
                      )
                    ) +
                    "\n      "
                )
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "table",
            {
              staticClass: "table mb-0 mx-3 w-auto",
              style: _vm.b_3343864469950044_style
            },
            [
              _c(
                "tbody",
                _vm._l(_vm.items, function(item) {
                  return _c("tr", { key: item.company_id }, [
                    _c(
                      "td",
                      { style: _vm.b_5477420070495986_style },
                      [
                        _c(
                          "b-form-checkbox",
                          {
                            attrs: { disabled: item.not_configured },
                            model: {
                              value: _vm.selectedCompanies[item.company_id],
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.selectedCompanies,
                                  item.company_id,
                                  $$v
                                )
                              },
                              expression: "selectedCompanies[item.company_id]"
                            }
                          },
                          [
                            _c("ItpText", {
                              attrs: { strong: "", text: item.company_name }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { style: _vm.b_6337614691287098_style },
                      [
                        item.not_configured
                          ? _c("ItpBadge", {
                              attrs: {
                                text: _vm._f("pgettext")(
                                  "Not configured",
                                  "NAVOnlineInvoiceInterface"
                                ),
                                variant: "warning"
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      { style: _vm.b_2406129194387753_style },
                      [
                        _c("ItpButton", {
                          attrs: {
                            icon: "mdi:cog",
                            text: _vm._f("pgettext")(
                              "Configure",
                              "Tasks|Command"
                            )
                          },
                          on: {
                            click: function($event) {
                              return _vm.evh_5615156174146796_click($event, {
                                item: item
                              })
                            }
                          }
                        })
                      ],
                      1
                    )
                  ])
                }),
                0
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "DIV",
            { staticClass: "card-footer bg-transparent" },
            [
              _c("JobHandlerControl", {
                attrs: {
                  jobType: "invoices:nav:pull-invoices",
                  "load-current": "",
                  disabled:
                    !_vm.selectedCompanyValues ||
                    !_vm.selectedCompanyValues.length,
                  payload: function() {
                    return { companies: _vm.selectedCompanyValues }
                  },
                  text: _vm._f("pgettext")(
                    "Pull new invoices from NAV services.",
                    "Tasks|Command"
                  ),
                  icon: _vm.$config.pullDataIcon
                }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }